export const state = {
  currencies: {},
}

export const getters = {
  currenciesList: state => Object.values(state.currencies),

  payInCurrenciesList: state => Object.values(state.currencies).filter(c => c.payIn),

  getCurrency: state => code => state.currencies[code],

  getAmountWithCurrency: (state, getters) => (amount, currencyCode = null) => {
    const currency = currencyCode ? getters.getCurrency(currencyCode) : getters.getCurrentCurrency

    let text = [
      amount,
      currency.symbol,
    ]

    if (currency.symbolFirst) {
      text = text.reverse()
    }

    return text.join(' ')
  },
}

export const mutations = {
  SET_CURRENCIES(state, currencies) {
    state.currencies = _.keyBy(currencies, 'code')
  },
}

export const actions = {
  fetchCurrencies({ commit }, type) {
    return api.get('/currencies', { type })
      .then(({ data }) => {
        return commit('SET_CURRENCIES', data.map(currency => ({
          name: currency.title,
          code: currency.key,
          symbol: currency.symbol,
          symbolFirst: currency.is_symbol_first,
          payIn: currency.is_payable,
        })))
      })
  },
}
